<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <section class="pt-6"  >
        <v-row justify="center" align="center">
          <v-col cols="8" class="text-center">
            <h1 class="text-h1">404 Error</h1>
          </v-col>
        </v-row>
 <v-row justify="center" align="center">
   <v-col cols="8" class="text-center">
     <p>No se encontro esta pagina.</p>
     <router-link to="/" class="text--white" exact>
       Regresar a la página principal
     </router-link>
   </v-col>
 </v-row>

      </section>

    </v-main>
    <piepagina />
  </v-app>
</template>

<script>
import Cabecerabaja from "@/components/general/cabecerabaja";
import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";

export default {
  name: "notfound",
  title: "Página de Error",
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
  },
}
</script>

<style scoped>

</style>
